import ConfirmStartSalesOrder from './ConfirmStartSalesOrder'

export default ConfirmStartSalesOrder
